export default {
	archivos:[
		{
			ident: "one",
			anio: "Ejercicios 2019",
			trimestres: "prie",
      info: "inform"
		},
		{
			"ident": "two",
			"anio": "Ejercicios 2020",
			"trimestres": "primer trimestre",
      info: "asfgs"
		}
	]	
}
